import { employerRoleList } from '../../../../configs/signUp';
import { useDispatch, useSelector } from '../../../../store/store';
import { selectEmail } from '../../../../store/signUp/selectors';
import MotionWrapper from '../../../../layouts/MotionWrapper';
import Button from '../../../../components/Button';
import Input from '../../../../components/Input';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { ListItem } from '../../../../store/general/types';
import {
    getStatesThunk,
    getCountriesThunk,
} from '../../../../store/general/thunks';
import { TypographyLogo } from '../../../../assets/icons';
import { updateInvitedMemberInfoThunk } from '../../../../store/workspace/thunks';
import { setSignUpStep } from '../../../../store/signUp/slice';
import { useSearchParams } from 'react-router-dom';
import { selectInviteMemberToken } from '../../../../store/workspace/selectors';

export default function MemberInfo() {
    const dispatch = useDispatch();
    const email = useSelector(selectEmail);
    const [isLoading, setIsLoading] = useState(false);
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [role, setRole] = useState<ListItem>({ title: '', id: '-1' });
    const [isValidFirstName, setIsValidFirstName] = useState(true);
    const [isValidLastName, setIsValidLastName] = useState(true);
    const [isValidRole, setIsValidRole] = useState(true);
    const [params, setParams] = useSearchParams();
    const paramToken = params.get('token');
    const token = useSelector(selectInviteMemberToken);

    useEffect(() => {
        dispatch(getCountriesThunk());
        dispatch(getStatesThunk());
    }, []);

    const next = () => {
        if (!lastName || !role.title || !firstName) {
            !role.title ? setIsValidRole(false) : setIsValidRole(true);
            !lastName ? setIsValidLastName(false) : setIsValidLastName(true);
            !firstName ? setIsValidFirstName(false) : setIsValidFirstName(true);
            return;
        }

        setIsValidLastName(true);
        setIsValidFirstName(true);
        setIsLoading(true);

        const info = {
            email,
            lastName,
            firstName,
            role: role.title,
            token: paramToken || token,
        };

        dispatch(updateInvitedMemberInfoThunk(info))
            .unwrap()
            .then(() => {
                dispatch(setSignUpStep('approval'));
            })
            .catch(error => {
                setIsLoading(false);
                console.log(error.message);
            })
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <div className={styles.head}>
                <TypographyLogo />
                <span className={styles.head_devider} />
                <span className={styles.head_title}>Sign Up</span>
            </div>
            <span className={styles.description}>
                Please complete the form to sign up:
            </span>
            <div className={styles.form}>
                <Input
                    isRequired
                    hasError={!isValidFirstName}
                    label='Legal first name'
                    type='text'
                    placeholder=''
                    value={firstName}
                    onChange={setFirstName}
                />
                <Input
                    isRequired
                    hasError={!isValidLastName}
                    label='Legal last name'
                    type='text'
                    placeholder=''
                    value={lastName}
                    onChange={setLastName}
                />
                <Input
                    isRequired
                    listShow
                    label='Your role'
                    type='text'
                    placeholder=''
                    value={role.title}
                    listIdKey='id'
                    listTitleKey='title'
                    hasError={!isValidRole}
                    list={employerRoleList}
                    onItemClick={(item: ListItem) => setRole(item)}
                    onChange={(val: string) => setRole({ id: '-1', title: val })}
                />

                <Button
                    onClick={next}
                    className={styles.next}
                    loading={isLoading}
                    text='Confirm'
                />
            </div>
        </MotionWrapper>
    );
};
